// utils/flags.js

export const getPrefixLocation = () => {
    const currentLocation = window.location.href;
  
    if (currentLocation.includes("staging")) {
      return "staging.";
    } else if (currentLocation.includes("dev")) {
      return "dev.";
    }
  
    return "";
  };
  
  export const setFlags = () => {
    const setCookie = (key, value) => {
      document.cookie = `${key}=${encodeURIComponent(value)}; domain=.ai-pro.org; path=/`;
    };
  
    const paramsToTrack = [
      'ppg', 'keyword', 'creative', 'emailid', 'adid', 'mode', 'flow', 'splash',
      'pmt', 'w_msg', 'gateway', 'force_gateway', 'swipe', 'bypasscountry', 'qW1eMlya',
      'via', 'vprice', 'tp_reviews', 'members', 'reg', 'regRedirectWP', 'WcvYPABR',
      'reg_google', 'kt8typtb', 'cta_clr_lp', 'cta_pmt', 'poweredby', 'mobDisplayPlan',
      'enterprise', 'cmpny', 'r_flow', 'locales', 'f_sle', 'verify', 'email_login',
      'login_token', 'emailopt', 'p_toggle', 'mode_test_no_pcheck', 'force_pmt',
      'rdct', 'price_click', 'reg_apple', 'vwo', 'pp_ctaclr', 'pp_cta', 'chatpdf',
      'cpdflink', 'click_id', 'daily', 'acwp_ux', 'rec2', 'ty_rdct', 'desc_align',
      'flux_app', 'country_code', 'ishoneypot'
    ];
  
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('ppg')) {
      setCookie('ppg', '97');
    }

    setCookie('chatpdfv2modal', 'true');
  
    paramsToTrack.forEach(param => {
      const value = urlParams.get(param);
      if (value !== null && value !== '') {
        setCookie(param, value);
      }
    });
  };
  
  export const getFlag = (paramName) => {
    const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
      const [key, value] = cookie.split('=');
      acc[key] = decodeURIComponent(value);
      return acc;
    }, {});
    return cookies[paramName] || null;
  };
  
  export const setWindowFlags = () => {


    window.mxname = "chatpdfv2.ai-pro.org";
    window.mxdebugMode = "false";
    window.mxuserEmail = getFlag('user_email') ?? "";
    window.mxuserPlan = getFlag('user_plan') ?? "";
    window.mxrewardfulVia = getFlag('via') ?? "";
    window.mxcurrency = getFlag('currency') ?? "USD";
    window.mxamount = getFlag('price') ?? "0";
    window.mxkeyword = getFlag('keyword') ?? "";
    window.mxemailid = getFlag('emailid') ?? "";
    window.mxadid = getFlag('adid') ?? "";
    window.mxppg = getFlag('ppg') ?? "";
    window.mxpmt = getFlag('pmt') ?? "";
    window.mxhowdoiplantouse = getFlag('howdoiplantouse') ?? "";
    window.mxremakemedloption = getFlag('remakemedloption') ?? "";
    window.mxtheme = getFlag('kt8typtb') ?? "";
    window.mxlocales = getFlag('locales') ?? "en";
    window.gaw_currency = getFlag('currency') ?? "USD";
  };
  
  export const handleRedirect = (path) => {
    window.location.href = path;
  };